module.exports = __webpack_public_path__ + "img/pecunia2.e8e4527d.png";